import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {PosterInGenerationWarningPanelProps} from '@Panels/poster-in-generation-warning-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-in-generation-warning-modal-panel';

export type PosterInGenerationWarningModalProps = PosterInGenerationWarningPanelProps;

export default function PosterInGenerationWarningModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.POSTER_IN_GENERATION_MODAL];
  });

  const height = '295px';
  const width = '600px';

  return (
    <Modal modalId={MODALS_IDS.POSTER_IN_GENERATION_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="poster-in-generation-warning-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterInGenerationWarningModal = (props: PosterInGenerationWarningModalProps = {}): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_IN_GENERATION_MODAL,
      panelProps: props,
    })
  );
};
